import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REFRESH_URL = `${API}/auth/refresh`;
let _refreshPromise = null;

export function isAuthEndpoint(url = '') {
  return url.endsWith('/auth/login') || url.endsWith('/auth/refresh') || url.endsWith('/auth/logout')
    || url.endsWith('/auth/forgot-password') || url.endsWith('/auth/reset-password')
    || url.endsWith('/auth/company-signup') || url.endsWith('/auth/register');
}

/**
 * Silent refresh-and-replay: on a 401 (expired 15-min access cookie) refresh once via the
 * long-lived refresh cookie and replay the ORIGINAL request, so a valid save succeeds on the
 * first click. Must be attached to EVERY axios instance (the default one AND axios.create()).
 */
export function attachAuthRefresh(instance) {
  if (instance.__civilxRefreshAttached) return instance;
  instance.__civilxRefreshAttached = true;
  instance.interceptors.response.use(
    (resp) => resp,
    async (error) => {
      const cfg = error?.config || {};
      const status = error?.response?.status;
      const fullUrl = `${cfg.baseURL || ''}${cfg.url || ''}`;
      if (status !== 401 || cfg._retryAfterRefresh || isAuthEndpoint(fullUrl)) {
        return Promise.reject(error);
      }
      try {
        if (!_refreshPromise) {
          _refreshPromise = axios.post(REFRESH_URL, {}, { withCredentials: true })
            .finally(() => { setTimeout(() => { _refreshPromise = null; }, 0); });
        }
        await _refreshPromise;
      } catch (refreshErr) {
        return Promise.reject(error);
      }
      cfg._retryAfterRefresh = true;
      cfg.withCredentials = true;
      return instance(cfg);
    },
  );
  return instance;
}

attachAuthRefresh(axios);

/** Pre-configured instance for modules that want baseURL=/api. */
export const createApiClient = (config = {}) => attachAuthRefresh(axios.create({ baseURL: API, withCredentials: true, ...config }));
